import "./styles/style.scss";

import { initSeeResultsBlocks } from "../site-poll/poll-front.js";

if (document.readyState === "loading") {
	document.addEventListener("DOMContentLoaded", initSeeResultsBlocks);
} else {
	initSeeResultsBlocks();
}
